var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"numBox"},[_c('div',{staticClass:"numBox"},_vm._l((_vm.dayData),function(item,index){return _c('div',{key:index,staticClass:"numItem"},[_c('div',{staticClass:"tranNum"},[_c('i',{ref:"numberItem",refInFor:true,staticClass:"visNum"},[_vm._v("0123456789")])])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fbe9fe1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloWorld.vue
// module id = null
// module chunks = 